<div class="container-fluid col-12 col-md-10">
    <app-speed-dial-fab (clicked)="dispatch($event)" [options]="FabOptions"></app-speed-dial-fab>

    <div class="card my-2">
        <h5 class="card-header">Conditions de prélèvement</h5>
        <div class="p-3">
            <div class="row">
                <div class="col-6">
                    <mat-form-field class="w-100">
                        <mat-label>Météo</mat-label>
                        <mat-select placeholder="Météo" [(ngModel)]="model.ConditionPrelevement.Meteo" required>
                            <mat-option *ngFor="let m of MeteoList; let i = index" [value]="i + 1">
                                <span>{{m}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field class="w-100">
                        <mat-label>Ensoleillement</mat-label>
                        <mat-select placeholder="Ensoleillement" [(ngModel)]="model.ConditionPrelevement.Ensoleillement" required>
                            <mat-option *ngFor="let e of EnsoleillementList; let i = index" [value]="i + 1">
                                <span>{{e}} </span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <mat-form-field class="w-100">
                        <mat-label>Hydrologie</mat-label>
                        <mat-select placeholder="Hydrologie" [(ngModel)]="model.ConditionPrelevement.Hydrologie" required>
                            <mat-option *ngFor="let h of HydrologieList; let i = index" [value]="i">
                                <span>{{h}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field class="w-100">
                        <mat-label>Variation débit</mat-label>
                        <mat-select placeholder="Variation débit" [(ngModel)]="model.ConditionPrelevement.VariationDebit" required>
                            <mat-option *ngFor="let v of VariationDebitList; let i = index" [value]="i">
                                <span>{{v}} </span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <mat-form-field class="w-100">
                        <mat-label>Limpidité</mat-label>
                        <mat-select placeholder="Limpidité" [(ngModel)]="model.ConditionPrelevement.Limpidite" required>
                            <mat-option *ngFor="let l of LimpiditeList; let i = index" [value]="i">
                                <span>{{l}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field class="w-100">
                        <mat-label>Visibilité</mat-label>
                        <mat-select placeholder="Visibilité" [(ngModel)]="model.ConditionPrelevement.Visibilite" required>
                            <mat-option *ngFor="let v of VisibiliteList; let i = index" [value]="i">
                                <span>{{v}} </span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                    <mat-form-field class="w-100">
                        <mat-label>Odeur</mat-label>
                        <mat-select placeholder="Odeur" [(ngModel)]="model.ConditionPrelevement.Odeur" required>
                            <mat-option *ngFor="let o of OdeurList; let i = index" [value]="i">
                                <span>{{o}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field class="w-100">
                        <mat-label>Teinte</mat-label>
                        <mat-select placeholder="Teinte" [(ngModel)]="model.ConditionPrelevement.Teinte" required>
                            <mat-option *ngFor="let t of TeinteList; let i = index" [value]="i + 1">
                                <span>{{t}} </span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                    <mat-form-field class="w-100">
                        <mat-label>Situation hydrologique 6 semaines précédentes</mat-label>
                        <mat-select placeholder="Situation hydrologique 6 semaines précédentes" [(ngModel)]="model.ConditionPrelevement.SituationHydro6Sem"
                                    required>
                            <mat-option *ngFor="let s of SituationHydro6semList; let i = index" [value]="i">
                                <span>{{s}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row" *ngIf="model.Type === EInterventionType.MGCE">
                <div class="col-6">
                    <mat-form-field class="w-100">
                        <mat-label>Sécurite Mise à l'eau</mat-label>
                        <mat-select placeholder="Sécurite Mise à l'eau" [(ngModel)]="model.ConditionPrelevement.SecuriteMiseALeau"
                                    required>
                            <mat-option *ngFor="let s of SecuriteMiseEauList; let i = index" [value]="i + 1">
                                <span>{{s}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-6"
                     *ngIf="model.ConditionPrelevement.SecuriteMiseALeau === ESecuriteMiseALeau.Difficile || 
                            model.ConditionPrelevement.SecuriteMiseALeau === ESecuriteMiseALeau.Dangereux">
                    <mat-form-field class="w-100">
                        <mat-label>Nature Danger</mat-label>
                        <input matInput placeholder="Nature Danger" [(ngModel)]="model.ConditionPrelevement.NatureDanger">
                    </mat-form-field>
                </div>
            </div>

        </div>
    </div>

    <div class="card my-2">
        <h5 class="card-header">Nature des berges</h5>
        <div class="p-3">
            <div class="row">
                <div class="col-6">
                    <mat-form-field class="w-100">
                        <mat-label>Occ. dom. rive gauche</mat-label>
                        <mat-select placeholder="Occ. dom. rive gauche" [(ngModel)]="model.NatureBerge.OccupationDominanteRG" required>
                            <mat-option *ngFor="let o of ODRGList; let i = index" [value]="i">
                                <span>{{o}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field class="w-100">
                        <mat-label>Occ. dom. rive droite</mat-label>
                        <mat-select placeholder="Occ. dom. rive droite" [(ngModel)]="model.NatureBerge.OccupationDominanteRD" required>
                            <mat-option *ngFor="let o of ODRDList; let i = index" [value]="i">
                                <span>{{o}} </span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <mat-form-field class="w-100">
                        <mat-label>Nature berge gauche</mat-label>
                        <mat-select placeholder="Nature berge gauche" [(ngModel)]="model.NatureBerge.NatureBergeGauche" required>
                            <mat-option *ngFor="let n of NatureBergeGaucheList; let i = index" [value]="i">
                                <span>{{n}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field class="w-100">
                        <mat-label>Nature berge droite</mat-label>
                        <mat-select placeholder="Nature berge droite" [(ngModel)]="model.NatureBerge.NatureBergeDroite" required>
                            <mat-option *ngFor="let n of NatureBergeDroiteList; let i = index" [value]="i">
                                <span>{{n}} </span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                    <mat-form-field class="w-100">
                        <mat-label>Importance végétation des berges</mat-label>
                        <mat-select placeholder="Importance végétation des berges" [(ngModel)]="model.NatureBerge.ImportanceVegetationBerge" required>
                            <mat-option *ngFor="let n of ImportanceVegetationList; let i = index" [value]="i + 1">
                                <span>{{n}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field class="w-100">
                        <mat-label>Type de végétation</mat-label>
                        <mat-select placeholder="Type de végétation" [(ngModel)]="model.NatureBerge.TypeVegetation" required>
                            <mat-option *ngFor="let n of VegetationTypetList; let i = index" [value]="i + 1">
                                <span>{{n}} </span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <mat-form-field class="w-100">
                        <mat-label>Aspect des abords</mat-label>
                        <mat-select placeholder="Aspect des abords" [(ngModel)]="model.NatureBerge.AspectAbord" required>
                            <mat-option *ngFor="let a of AspectAbordList; let i = index" [value]="i + 1">
                                <span>{{a}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>

    <div class="card my-2">
        <h5 class="card-header">Morphologie du lit</h5>
        <div class="p-3">
            <div class="row">
                <div class="col-6">
                    <mat-form-field class="w-100">
                        <mat-label>Présence d'un seuil</mat-label>
                        <mat-select placeholder="Présence d'un seuil" [(ngModel)]="model.MorphologieLit.PresenceSeuil" required>
                            <mat-option *ngFor="let p of PresenceSeuilList; let i = index" [value]="i">
                                <span>{{p}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field class="w-100">
                        <mat-label>Présence d'un gué</mat-label>
                        <mat-select placeholder="Présence d'un gué" [(ngModel)]="model.MorphologieLit.PresenceGue" required>
                            <mat-option *ngFor="let p of PresenceGueList; let i = index" [value]="i">
                                <span>{{p}} </span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                    <mat-form-field class="w-100">
                        <mat-label>Colmatage général du lit</mat-label>
                        <mat-select placeholder="Colmatage général du lit" [(ngModel)]="model.MorphologieLit.ColmatageLit" required>
                            <mat-option *ngFor="let p of ColmatageLitList; let i = index" [value]="i + 1">
                                <span>{{p}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.MorphologieLit.Canalisation">Canalisation</mat-slide-toggle>
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.MorphologieLit.Navigation">Navigation</mat-slide-toggle>
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.MorphologieLit.Curage">Curage</mat-slide-toggle>
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.MorphologieLit.Recalibrage">Recalibrage</mat-slide-toggle>
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.MorphologieLit.Rectification">Rectification</mat-slide-toggle>
            </div>
        </div>
    </div>

    <div class="card my-2">
        <h5 class="card-header">Qualité visuelle de l'eau</h5>
        <div class="p-3">
            <div class="row">
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.QualiteVisuelleEau.Irisation">Irisation</mat-slide-toggle>
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.QualiteVisuelleEau.PresenceMousseDetergent">Présence de mousses ou détergents</mat-slide-toggle>
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.QualiteVisuelleEau.PresenceDebrisLigneuxFrais">Présence de débrits ligneux frais</mat-slide-toggle>
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.QualiteVisuelleEau.PresenceBoueOrgaFlottante">Présence de boue organique flottante</mat-slide-toggle>
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.QualiteVisuelleEau.PositionRejetEventuel">Position de rejets éventuels
                </mat-slide-toggle>
            </div>

            <div class="row mt-2">
                <div class="col-6">
                    <mat-form-field class="w-100">
                        <mat-label>Présence rejet</mat-label>
                        <mat-select placeholder="Présence rejet" [(ngModel)]="model.QualiteVisuelleEau.PresenceRejet" required>
                            <mat-option *ngFor="let p of PresenceRejetList; let i = index" [value]="i">
                                <span>{{p}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field class="w-100">
                        <mat-label>Nature du rejet</mat-label>
                        <input matInput placeholder="Nature du rejet" [(ngModel)]="model.QualiteVisuelleEau.NatureRejet">
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>

    <div class="card my-2">
        <h5 class="card-header">Faciès d'écoulement</h5>
        <div class="p-3">
            <div class="row">
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.FaciesEcoulement.ChenalLentique">Chenal lentique</mat-slide-toggle>
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.FaciesEcoulement.FosseDissipation">Fosse dissipation</mat-slide-toggle>
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.FaciesEcoulement.MouilleConcavite">Mouille concavité</mat-slide-toggle>
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.FaciesEcoulement.FosseDaffouillement">Fosse d'affouillement flottante</mat-slide-toggle>
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.FaciesEcoulement.ChenalLotique">Chenal lotique</mat-slide-toggle>
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.FaciesEcoulement.PlatLentique">Plat Lentique</mat-slide-toggle>
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.FaciesEcoulement.PlatCourant">Plat courant</mat-slide-toggle>
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.FaciesEcoulement.Radier">Radier </mat-slide-toggle>
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.FaciesEcoulement.Rapide">Rapide</mat-slide-toggle>
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.FaciesEcoulement.Cascade">Cascade</mat-slide-toggle>
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.FaciesEcoulement.Chute">Chute</mat-slide-toggle>
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.FaciesEcoulement.BancConvexite">Banc de convexité </mat-slide-toggle>
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.FaciesEcoulement.Escalier">Escalier</mat-slide-toggle>
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.FaciesEcoulement.EauMorteLone">Eau morte - Lone</mat-slide-toggle>
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.FaciesEcoulement.LentiqueIndetermine">Lentique indéterminé</mat-slide-toggle>
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.FaciesEcoulement.LotiqueIndetermine">Lotique indéterminé</mat-slide-toggle>
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.FaciesEcoulement.SousBerge">Sous berge</mat-slide-toggle>
                <mat-slide-toggle class="col-12 col-md-6 col-xl-4" [(ngModel)]="model.FaciesEcoulement.ZoneDeBordure">Zone de bordure </mat-slide-toggle>
            </div>
        </div>
    </div>

    <div class="card my-2" *ngIf="model.PhysiqueChimieInSitu.IsMandatory">
        <h5 class="card-header">Paramètre physico-chimiques in-situ</h5>
        <div class="p-3">
            <div class="row">
                <div class="col">
                    <mat-form-field class="w-100">
                        <mat-label>Température Air (°C)</mat-label>
                        <input matInput placeholder="Température Air (°C)" type="number" [(ngModel)]="model.PhysiqueChimieInSitu.TemperatureAir">
                    </mat-form-field>
                </div>
            </div>
            <div *ngIf="coreData.IsMobile" class="row justify-content-center my-1">
                <mat-icon>more_horiz</mat-icon>
            </div>
            <div class="row">
                <div class="col-auto col-md-6">
                    <mat-form-field class="w-100">
                        <mat-label>Température Eau (°C)</mat-label>
                        <input matInput placeholder="Température Eau (°C)" type="number" [(ngModel)]="model.PhysiqueChimieInSitu.TemperatureEau" [formControl]="WaterTemperatureControl">
                        <mat-error align="end">Température de l’eau > 30</mat-error>
                    </mat-form-field>
                </div>
                <!-- <div *ngIf="model.Type !== 4" class="col-2 d-flex align-items-center p-0">
                    <mat-checkbox [(ngModel)]="model.PhysiqueChimieInSitu.COFRACTemperatureEau">COFRAC</mat-checkbox>
                </div> -->
                <!-- <div class="col">
                    <mat-form-field class="w-100">
                        <mat-label>Numéro sonde</mat-label>
                        <input matInput placeholder="Numéro sonde" [(ngModel)]="model.PhysiqueChimieInSitu.SondeEau">
                    </mat-form-field>
                </div> -->
                <div class="col">
                    <mat-form-field class="w-100">
                        <mat-label>Température Eau Corrigée (°C)</mat-label>
                        <input matInput placeholder="Température Eau Corrigée (°C)" [ngModel]="computeTemperatureFormula(model.PhysiqueChimieInSitu.TemperatureEau) | number: '1.1-2'" readonly>
                    </mat-form-field>
                </div>
            </div>
            <div *ngIf="coreData.IsMobile" class="row justify-content-center my-1">
                <mat-icon>more_horiz</mat-icon>
            </div>
            <div class="row">
                <div class="col-auto col-md-6">
                    <mat-form-field class="w-100">
                        <mat-label>pH</mat-label>
                        <input matInput placeholder="pH" type="number" [(ngModel)]="model.PhysiqueChimieInSitu.pH" [formControl]="PHControl">
                        <mat-error align="end">pH < 5 ou> 10</mat-error>
                    </mat-form-field>
                </div>
                <!-- <div *ngIf="model.Type !== 4" class="col-2 d-flex align-items-center p-0">
                    <mat-checkbox [(ngModel)]="model.PhysiqueChimieInSitu.COFRACpH">COFRAC</mat-checkbox>
                </div> -->
                <div class="col">
                    <mat-form-field class="w-100">
                        <mat-label>Numéro sonde pH</mat-label>
                        <mat-select placeholder="N° Sonde pH" [(ngModel)]="model.PhysiqueChimieInSitu.SondePh" required>
                            <mat-option *ngFor="let o of SondePhList;" [value]="o.Reference" [disabled]="!o.IsActive">
                                <span>{{o.Reference}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div *ngIf="coreData.IsMobile" class="row justify-content-center my-1">
                <mat-icon>more_horiz</mat-icon>
            </div>
            <div class="row">
                <div class="col-auto col-md-6">
                    <mat-form-field class="w-100">
                        <mat-label>Conductivité (µS/cm)</mat-label>
                        <input matInput placeholder="Conductivité (µS/cm)" type="number" [(ngModel)]="model.PhysiqueChimieInSitu.Conductivite" [formControl]="ConductivityControl">
                        <mat-error align="end">Conductivité < 10 et> 1500</mat-error>
                    </mat-form-field>
                </div>
                <!-- <div *ngIf="model.Type !== 4" class="col-2 d-flex align-items-center p-0">
                    <mat-checkbox [(ngModel)]="model.PhysiqueChimieInSitu.COFRACConductivite">COFRAC</mat-checkbox>
                </div> -->
                <div class="col">
                    <mat-form-field class="w-100">
                        <mat-label>Numéro sonde Conductivité</mat-label>
                        <!-- <input matInput placeholder="Numéro sonde" [(ngModel)]="model.PhysiqueChimieInSitu.SondeConductivite"> -->
                        <mat-select placeholder="N° Sonde Conductivité" [(ngModel)]="model.PhysiqueChimieInSitu.SondeConductivite" required>
                            <mat-option *ngFor="let o of SondeConductiviteList;" [value]="o.Reference" [disabled]="!o.IsActive">
                                <span>{{o.Reference}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div *ngIf="coreData.IsMobile" class="row justify-content-center my-1">
                <mat-icon>more_horiz</mat-icon>
            </div>
            <div class="row">
                <div class="col-auto col-md-6">
                    <mat-form-field class="w-100">
                        <mat-label>Oxygène Dissous (mg/L O2)</mat-label>
                        <input matInput placeholder="Oxygène Dissous  (mg/L O2)" type="number" [(ngModel)]="model.PhysiqueChimieInSitu.OxygeneDissous" [formControl]="OxygenControl">
                        <mat-error align="end">Oxygène dissous : > 13</mat-error>
                    </mat-form-field>
                </div>
                <!-- <div *ngIf="model.Type !== 4" class="col-2 d-flex align-items-center p-0">
                    <mat-checkbox [(ngModel)]="model.PhysiqueChimieInSitu.COFRACOxygeneDissous">COFRAC</mat-checkbox>
                </div> -->
                <div class="col">
                    <mat-form-field class="w-100">
                        <mat-label>Numéro sonde Oxyygène</mat-label>
                        <!-- <input matInput placeholder="Numéro sonde " [(ngModel)]="model.PhysiqueChimieInSitu.SondeOxygene"> -->
                        <mat-select placeholder="N° Sonde Oxyygène" [(ngModel)]="model.PhysiqueChimieInSitu.SondeOxygene" required>
                            <mat-option *ngFor="let o of SondeOxygeneList;" [value]="o.Reference" [disabled]="!o.IsActive">
                                <span>{{o.Reference}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div *ngIf="coreData.IsMobile" class="row justify-content-center my-1">
                <mat-icon>more_horiz</mat-icon>
            </div>
            <div class="row">
                <div class="col-auto col-md-6">
                    <mat-form-field class="w-100">
                        <mat-label>Saturation O2d (%)</mat-label>
                        <input matInput placeholder="Saturation O2d (%)" type="number" [(ngModel)]="model.PhysiqueChimieInSitu.SaturationO2d" [formControl]="SaturationControl">
                        <mat-error align="end">Saturation < 13 ou saturation> 150</mat-error>
                    </mat-form-field>
                </div>
                <!-- <div *ngIf="model.Type !== 4" class="col-2 d-flex align-items-center p-0">
                    <mat-checkbox [(ngModel)]="model.PhysiqueChimieInSitu.COFRACSaturationO2d">COFRAC</mat-checkbox>
                </div> -->
            </div>
        </div>
    </div>
</div>